/**
 * Footer translations
 * 
 * This file contains translations for the footer section of the application.
 */

import { FooterTranslationType } from './types';

// English translations
export const enFooter: FooterTranslationType = {
  footer: {
    feedback: "Feedback",
    copyright: "2025, Made with",
    by: "by Bùi Tiến Tuân"
  }
};

// Vietnamese translations
export const viFooter: FooterTranslationType = {
  footer: {
    feedback: "Phản Hồi",
    copyright: "2025, Được tạo với",
    by: "bởi Bùi Tiến Tuân"
  }
};